import { useEffect, useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { emailSchema } from '@bliks-io/contracts';
import { LoginPage } from '@/pages/auth/login/loginPage';
import { createAuthGuard } from '@/lib/auth/routeGuards';

interface LoginSearch {
  login_hint?: string;
}

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    login_hint: typeof search.login_hint === 'string' ? search.login_hint : undefined
  }),
  component: LoginRouteComponent,
  beforeLoad: createAuthGuard()
});

function LoginRouteComponent() {
  const { login_hint: loginHint } = Route.useSearch();
  const navigate = Route.useNavigate();
  const [prefillEmail] = useState(() => emailSchema().safeParse(loginHint).data);

  useEffect(
    function stripLoginHintFromUrl() {
      // Keeps the address out of history and Referer.
      if (loginHint === undefined) return;
      void navigate({ search: {}, replace: true });
    },
    [loginHint, navigate]
  );

  return <LoginPage prefillEmail={prefillEmail} />;
}
